// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1j5GE","validationTips":"StatementDescriptor_validationTips__3aQHg"};